import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import en from '../../../../lang/en-us';
import { BoxDataType } from '.';
import { PurchaseDetailsBox } from './PurchaseDetailsBox';
import { AccountTypes, getAccountType } from '../../../../redux-store/types/portfolio';

const { dbCommercial } = en;
import { getAmcList } from '../../../../redux-store/actions/nct';
import { RouteComponentProps } from 'react-router';

export default function BankDetailsPurchase(props: any) {
    const { apiData, kfinFlag } = props;
    const formattedBankData = [
        {
            label: dbCommercial.newPurchase.rightMenu.bank.accountNo,
            value: apiData?.bank[0].accountNo,
            isEditable: false,
            apiKey: 'accountNumber',
            name: 'accountNumber',
        },
        {
            label: dbCommercial.newPurchase.rightMenu.bank.ifsc,
            value: apiData?.bank[0].ifsc,
            isEditable: false,
            apiKey: 'ifscCode',
            name: 'ifscCode',
        },
        {
            label: dbCommercial.newPurchase.rightMenu.bank.accountType,
            value: getAccountType(kfinFlag ? apiData?.bank[0].accountType : ""),
            isEditable: false,
            apiKey: 'accountType',
            name: 'accountType',
        },
        {
            label: dbCommercial.exploreMfs.mfInvestment.bank.branch,
            value: apiData?.bank[0].branch,
            isEditable: false,
            apiKey: 'branch',
            name: 'branch',
        },
    ];
    return (
        <div className="purchase-section">
            <h2>{dbCommercial.newPurchase.leftMenu.bankDetails}</h2>
            <PurchaseDetailsBox
                boxDetails={formattedBankData}
                heading={(apiData?.bank[0] || {})?.name || ''}
                editRedirect={`${props.isin}/edit/bank`}
                preFillData={{ ...apiData?.bank[0], kfinFlag }}
                preFillDataKey={'bankDetails'}
                errorSection={props.errorSection}
            />
        </div>
    );
}
